/** Paradise Genesis Collection V2 — highlight in admin NFT refresh reports */
export const PTGC_V2_ADDRESS = '0xab7f2d4b6a1f9d9c698388af7ab88bc16ea368b1';

/**
 * @param {unknown} tokens
 * @returns {{ total: number, byCollection: Record<string, number>, byAddress: Record<string, number> }}
 */
export function summarizeOwnedTokens(tokens) {
  const list = Array.isArray(tokens) ? tokens : [];
  /** @type {Record<string, number>} */
  const byCollection = {};
  /** @type {Record<string, number>} */
  const byAddress = {};

  for (const token of list) {
    if (!token || typeof token !== 'object') continue;
    const name = token.contract_name || token.contractName || 'Unknown';
    const addr = String(token.contract_address || token.contractAddress || '').toLowerCase();
    byCollection[name] = (byCollection[name] || 0) + 1;
    if (addr) {
      byAddress[addr] = (byAddress[addr] || 0) + 1;
    }
  }

  return { total: list.length, byCollection, byAddress };
}

/**
 * @param {{ byCollection: Record<string, number> }} before
 * @param {{ byCollection: Record<string, number> }} after
 * @returns {Array<{ collection: string, before: number, after: number, change: number }>}
 */
export function buildCollectionDelta(before, after) {
  const keys = new Set([
    ...Object.keys(before.byCollection || {}),
    ...Object.keys(after.byCollection || {}),
  ]);

  return [...keys]
    .map((collection) => {
      const b = before.byCollection[collection] || 0;
      const a = after.byCollection[collection] || 0;
      return { collection, before: b, after: a, change: a - b };
    })
    .sort(
      (x, y) =>
        Math.abs(y.change) - Math.abs(x.change) ||
        y.after - x.after ||
        x.collection.localeCompare(y.collection),
    );
}

/**
 * @param {{ byAddress: Record<string, number> }} summary
 * @param {string} address
 * @returns {number}
 */
export function countForAddress(summary, address) {
  return summary?.byAddress?.[address.toLowerCase()] || 0;
}
